// Generated by genversion.
module.exports = '0.25.1'
